module.exports = __webpack_public_path__ + "img/JMMSpeech.7ec8e7ba.png";